<div class="learnset-widget">
  <i class="fas fa-layer-group"></i>
  <span class="name">{{learnset.name}}</span>
  
  <div *ngIf="learnset.openCards > 0" class="open-cards">
    <i class="fas fa-repeat"></i>
    <span>{{learnset.openCards}}</span>
  </div>

  <i *ngIf="learnset.openCards === 0" class="fas fa-check-circle"></i>
</div>
